export default __webpack_public_path__ + "static/media/gift.8f13732a.png";